module.exports = __webpack_public_path__ + "static/media/sigelu.08d3765d.svg";